/**
 * Format generations-left for display (C4). C1 contract: `remaining === null`
 * means UNLIMITED (NOT zero); `undefined` means usage isn't loaded yet. Kept in
 * one tiny pure helper so the null===unlimited rule lives once across the navbar,
 * action bar, and job-detail.
 */
export type UsageWindow = 'year' | 'cycle'

/** `window` defaults to 'year' so existing call sites stay correct while they
 * migrate; cycle copy says "month" because every sub price is monthly (plan
 * Decision 1 — revisit only if annual billing ever ships, a plan non-goal). */
export function formatGenerationsLeft(
  remaining: number | null | undefined,
  window: UsageWindow = 'year',
): string {
  if (remaining === undefined) return '—'
  if (remaining === null) return 'Unlimited'
  return `${remaining} generation${remaining === 1 ? '' : 's'} left this ${
    window === 'cycle' ? 'month' : 'year'
  }`
}
